
import moment from "moment";
import { BaseResponse } from "../models/BaseResponse";
import { useAuth } from "./AuthContext";

export class APIService {

    private _apiUrl;

    private _loginContext = useAuth();
    
    constructor(){
        this._apiUrl =  process.env.REACT_APP_BASE_URL;
         // Make sure no timezone overwrite to dates for API
         // eslint-disable-next-line no-extend-native
         Date.prototype.toJSON = function () {
            return moment(this).format("YYYY-MM-DDTHH:mm:ss");
        };
    }

    private async getRequestInit<P>( method: string, payload?: P, token?: string | null): Promise<RequestInit>{
        //const token = await this._getToken();
        const contentType: string = (method === "POST"?'application/json': '' );
        const headers: HeadersInit = [];
        headers.push(['Content-Type', contentType]);
        if(token){
            headers.push(['Authorization', `Bearer ${token}`]);
        }
        return { method: method,
        headers: headers,
        body: (payload?JSON.stringify(payload): null)}
    }

    private handleLogout = async () => {
        await this._loginContext.logout();
    }

    public async sendRequest<T,P>(url: string, method: string, payload?: P, token?: string | null): Promise<T>{
        let responsePromise:  Promise<BaseResponse<T>> | null = null;
        
        await fetch(this._apiUrl + url,await this.getRequestInit(method, payload, token)
            ).then((response) => {
                if(response.status === 401) {
                    this.handleLogout();

                    if (window.location.pathname !== '/login') {
                        window.location.replace('/login');
                    }
                } else {
                    responsePromise = response.json();
                }
            });
        if(responsePromise){
            return Promise.resolve(responsePromise);
        }
        else{
            return Promise.resolve({} as T);
        }
    }
    
    /*public async isAdminUser(): Promise<BaseResponse<boolean>> {
        return this.sendRequest<BaseResponse<boolean>,unknown>("User/IsAdminUser","GET");
    }*/
}